import React, { useState } from 'react';
import styles from './CopyButton.module.scss';

interface CopyButtonProps {
  textToCopy: string;
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

const CopyButton: React.FC<CopyButtonProps> = ({
  textToCopy,
  size = 'small',
  className = ''
}) => {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  const iconClass = copied ? 'icon-dashboard-icons_checkmark' : 'icon-dashboard-icons_link';
  const buttonClass = `${styles.copyButton} ${styles[size]} ${className}`;

  return (
    <button
      type="button"
      onClick={copyToClipboard}
      className={buttonClass}
      title={copied ? 'Copied!' : 'Copy to clipboard'}
    >
      <i className={iconClass} />
    </button>
  );
};

export default CopyButton;
